;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import * as Sentry from "@sentry/nextjs";

export function reportRouteError({
	digest,
	error,
	segment,
}: {
	digest?: string;
	error: Error & { digest?: string };
	segment: string;
}): void {
	const serverDigest = digest ?? error.digest;

	// A digest means the error was thrown server-side and already captured by
	// `onRequestError`; the client copy only carries a generic message. Keep it
	// (it still triggers error-sampled Replay) but as a separate, lower-severity
	// group that links back to the server issue via `serverDigest`.
	if (serverDigest) {
		Sentry.captureException(error, {
			fingerprint: ["route-error-boundary", segment, "server-rendered"],
			level: "warning",
			tags: {
				"route_error.section": "route-error-boundary",
				"route_error.segment": segment,
				serverDigest,
			},
		});
		return;
	}

	Sentry.captureException(error, {
		tags: {
			"route_error.section": "route-error-boundary",
			"route_error.segment": segment,
		},
	});
}
